/* eslint-disable quote-props, max-len */

export default {
  'season': ({ seasonNumber }) => `Säsong ${seasonNumber}`,
  'episode': ({ episodeNumber }) => `Episod ${episodeNumber}`,
  'parentalControl.enterPin': 'Det här programmet är inte är lämpligt för yngre personer, ange din verifieringskod för att titta ändå',
  'adInfo': ({ ads, adsCount }) => `Annons ${ads} av ${adsCount}`,
  'visitAd': 'Besök annonsören',
  'skipAd': 'Hoppa över',
  'skipAdInTime': ({ time }) => `Hoppa över om ${time}`,
  'chromecast.castingTo': 'Castar till',
  'chromecast.onboardingLabel': 'Casta till din TV',
  'playerSettings.audio': 'Ljudspråk',
  'playerSettings.subtitles': 'Undertexter',
  'playerSettings.quality': 'Kvalitet',
  'playerSettings.off': 'Av',
  'playerSettings.auto': 'Auto',
  'playerSettings.high': 'Hög',
  'playerSettings.medium': 'Medium',
  'playerSettings.low': 'Låg',
  'playerError.noSubscription': 'Detta program ingår ej i ditt abonnemang',
  'playerError.countryPermission': 'Detta program är ej tillgängligt i denna region',
  'playerError.trafficOverload': 'Det verkar vara mycket trafik just nu, vänligen försök senare.',
  'playerError.upgradeSubscription': 'Du behöver uppdatera ditt abonnemang för att se denna kanal',
  'playerError.notAvailable': 'Detta program är ej tillgängligt',
  'playerError.noLongerAvailable': 'Onej! Detta program är inte längre tillgängligt.',
  'playerError.anotherPlayer': 'Det verkar som att du redan har tjänsten igång på annan enhet.',
  'playerError.verifyEmail': 'Verifiera din email för att se detta program.',
  'playerError.parentalControl': 'Föräldrakontroll är aktiverad',
  'playerError.wrongPIN': 'Felaktig verifieringskod. Försök igen.',
  'playerError.cannotChromecast': 'Detta program går ej att se via Chromecast.',
  'playerError.tooManyDevices': 'Du har kommit upp i max antal enheter. Var vänlig töm din lista.',
  'playerError.enterPostcode': 'Vänligen fyll i ditt postnummer.',
  'playerError.wrongRegion': 'Du befinner dig i en region där våra tjänster inte är tillgängliga',
  'playerError.noDRM': 'Den här enheten har inte stöd för att spela upp krypterat material.',
  'playerError.noLiveRights': 'Detta program är inte tillgängligt att titta på live',
  'playerError.browser': 'Din webbläsare kan inte läsa innehållet. Testa att installera om din webbläsare eller använd en annan.',
  'playerError.adblockerDetected': 'Se till så att du inte har en adblocker aktiverad eller kontrollera din internetanslutning',
  'playerError.entitlementUnauthorized': 'Din session är inte längre giltig. Försöka igen efter du har loggat ut och in.',
  'playerError.forbiddenProxy': 'Detta program är ej tillgängligt när du använder en proxy eller VPN',
  'playerError.licenseRejected': 'Av rättighetsskäl kan vi inte spela den här kanalen i den här webbläsaren.',
  'playerError.outputRestricted': 'Due to license restrictions, playback is not supported on this display.',
  'playerError.serverError': ({ code }) => `Anropet misslyckades, felkod ${code}. Vänligen försök igen.`,
  'playerError.networkError': 'Nätverksfel, vänligen försök igen.',
  'playerOverlays.pauseOverlay': 'När du trycker på play börjar du spela livesändningen',
  'error': 'Ett fel uppstod. Försök igen.',
  'nextVideo.label': 'Nästa avsnitt',
  'nextVideo.timer': ({ time }) => `om ${time}`,
};
